import { planningAPI } from "../../axios";

export const actions = {
    //Planning Template
    CreatePlanningTarget(context, data){
        return planningAPI.post(`PlanningTarget/Add`, data);
    },
    UpdatePlanningTarget(context, data){
        return planningAPI.put(`PlanningTarget/Update/${data.id}`, data);
    },
    DeletePlanningTarget(context, data){
        return planningAPI.delete(`PlanningTarget/Delete/${data}`);
    },
    GetSinglePlanningTarget(context, data){
        return planningAPI.get(`PlanningTarget/${data}`);
    },
    GetAllPlanningTarget(context, data){
        return planningAPI.get(`PlanningTarget/MainTarget/${data}`);
    },
    GetPlanningTargetByDU(context, data){
        return planningAPI.get(`PlanningTarget/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPostedPlanningTargetByDU(context, data){
        return planningAPI.get(`PlanningTarget/Posted/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPostedPlanningTargetSummary(context, data){
        return planningAPI.get(`PlanningTarget/Posted/Summary/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPostedPlanningTargetByDepartment(context, data){
        return planningAPI.get(`PlanningTarget/Posted/Department/${data.departmentId}/${data.cycle}`);
    },
    GetPlanningTargetAvailable(context, data){
        return planningAPI.get(`PlanningTarget/Available/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPostedByCampus(context, data){
        return planningAPI.get(`PlanningTarget/Posted/Campus/${data.campusId}/${data.cycle}`);
    },
    GetSummaryPostedByCampus(context, data){
        return planningAPI.get(`PlanningTarget/Summary/Posted/${data.cycle}/${data.campusId}`);
    },
    GetAllPostedByCampus(context, data){
        return planningAPI.get(`PlanningTarget/Summary/All/${data.cycle}/${data.campusId}`);
    },
    GetTargetByOPCR(context, data){
        return planningAPI.get(`PlanningTarget/PreOpcr/${data}`);
    },
    AddTagByTarget(context, data){
        return planningAPI.post(`PlanningTarget/Tag/Add`, data);
    },
    GetTagsByTarget(context, data){
        return planningAPI.get(`PlanningTarget/Tags/${data}`);
    },
    RemoveTags(context, data){
        return planningAPI.delete(`PlanningTarget/Tag/Remove/${data}`);
    },
    GetDepartmentsByTarget(context, data){
        return planningAPI.get(`PlanningTarget/Departments/${data}`);
    },
    ShowInDepartment(context, data){
        return planningAPI.put(`PlanningTarget/ShowInDepartment/${data.id}/${data.showInDepartment}`);
    }
}